export default "__VITE_ASSET__eJ7O9m2p__"